import { useEffect } from 'react';
import styled from 'styled-components';

import { Breadcrumb } from 'ui/breadcrumb';
import { PAGE_HEADER_VARIANTS } from 'ui/pageHeader/constants';
import { fontSizes, spacing, WebLink } from 'ui/theme';

import { usePanelContext } from '../../contexts/Panel';
import { useUploadAssetsContext } from '../../contexts/UploadAssetsContext';
import { useTranslations } from '../../hooks/useTranslations';
import { DropZoneArea, PanelIntent, PanelView } from '../../types';
import { AssetListEmptyState } from '../AssetListEmptyState';
import { DropZone } from '../DropZone';
import { AssetListPending } from './AssetList';

const UploadViewBody = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  height: 100%;
  row-gap: ${spacing.base};
`;

const ControlSection = styled.section`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: ${spacing.half};
  > *:first-child > div {
    margin-bottom: 0;
  }
`;

const StyledWebLink = styled(WebLink)`
  font-size: ${fontSizes.s12};
`;

export const testIds = {
  breadcrumb: 'cl-panel-upload-breadcrumb',
  remoteUrlLink: 'cl-panel-upload-remot-url-link',
};

export const PanelViewUpload = () => {
  const { t } = useTranslations();
  const { pendingImages, removeCompletedUploads } = useUploadAssetsContext();
  const { panelIntent, setPanelView } = usePanelContext();

  useEffect(() => {
    // componentWillUnmount
    return () => {
      removeCompletedUploads();
    };
  }, []);

  return (
    <UploadViewBody>
      <ControlSection data-test={testIds.breadcrumb}>
        <Breadcrumb
          isButton
          breadcrumb={{
            content: t('link.imageLibrary'),
            onClick: () => setPanelView(PanelView.List),
          }}
          variant={PAGE_HEADER_VARIANTS.SECONDARY}
        />
        {panelIntent !== PanelIntent.Browse && (
          <StyledWebLink
            data-test={testIds.remoteUrlLink}
            onClick={() => setPanelView(PanelView.RemoteUrl)}
          >
            {t('menu.linkRemote')}
          </StyledWebLink>
        )}
      </ControlSection>
      <DropZone area={DropZoneArea.Panel}>
        {pendingImages.length ? <AssetListPending /> : <AssetListEmptyState isPanel />}
      </DropZone>
    </UploadViewBody>
  );
};
